import React, { FC, ReactElement } from 'react';
import { StyledChip } from './styles';
import { ConnectorStageChipProps } from './model';

const ConnectorStageChip: FC<ConnectorStageChipProps> = ({
  stage,
}): ReactElement => {
  return <StyledChip label={stage} />;
};

export default ConnectorStageChip;
